import { FBBlue, Facebook, Google } from "@assets/index";
import React, { useEffect, useState } from "react";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { parsePhoneNumber } from "react-phone-number-input";
import OTPInput from "react-otp-input";

import styles from "./styles";
import { useResendOtpMutation, useUserSignupMutation, useVerifyOtpMutation } from "./signupSlice";
import LocalStorage from "@Utils/storage";
import { Tokens } from "@Constants/common";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@Constants/routes";
import { displayToast } from "@Utils/toast";
import { setUser } from "@Pages/Profile/profileSlice";
import { useAppDispatch } from "@Store/store";
import { CheckCircledIcon, CheckIcon } from "@radix-ui/react-icons";

import { CheckPasswordStrength, deleteUTMCookies, getReferralIdFromCookie, getUtmParamsFromCookies } from "@Utils/common";

const SignupForm = () => {
    const navigate = useNavigate();

    // const notify = () => toast.error("Wow so easy !", { theme: 'colored'});

    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [firstName, setFirstName] = useState<string>("");
    const [lastName, setLastName] = useState<string>("");
    const [phoneNumber, setPhoneNumber] = useState<string | any>("");
    const [isPasswordStrong, setIsPasswordStrong] = useState(false);

    const [errors, setErrors] = useState<{ [key: string]: string }>({});


    const [refId, setRefId] = useState<string | null>("");


    const [
        userSignup,
        {
            data: userSignupData,
            error: userSignupErr,
            isLoading: userSignupLoading,
        },
    ] = useUserSignupMutation();

    useEffect(() => {
        const referral_id = getReferralIdFromCookie();
        setRefId(referral_id);

    }, [])



    const dispatch = useAppDispatch();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {

        if (e?.target?.name == "email") setEmail(e.target.value);
        if (e?.target?.name == "password") setPassword(e.target.value);
        if (e?.target?.name == "firstname") setFirstName(e.target.value);
        if (e?.target?.name == "lastname") setLastName(e.target.value);
        if (e?.target?.name == "phonenumber") setPhoneNumber(e.target.value);
    };


    useEffect(() => {
        const passwordStrength = CheckPasswordStrength(password);
        setIsPasswordStrong(passwordStrength);
    }, [password]);

    const validateFields = () => {
        const newErrors: { [key: string]: string } = {};

        if (!firstName.trim()) {
            newErrors.firstname = "First name is required";
        }

        if (!lastName.trim()) {
            newErrors.lastname = "Last name is required";
        }

        if (!email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
            newErrors.email = "Invalid email format";
        }

        if (!phoneNumber) {
            newErrors.phonenumber = "Phone number is required";
        } else {
            try {
                const parsed = parsePhoneNumber(phoneNumber);
                if (!parsed || !parsed.isValid()) {
                    newErrors.phonenumber = "Invalid phone number";
                }
            } catch (err) {
                newErrors.phonenumber = "Invalid phone number";
            }
        }

        if (!password) {
            newErrors.password = "Password is required";
        } else if (!CheckPasswordStrength(password)) {
            newErrors.password = "Password is not strong enough";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };


    const onSubmitClick = (e: any) => {
        e.preventDefault();
        // notify()
        if (!validateFields()) {
            displayToast("error", "Please fix the highlighted errors.");
            return;
        }

        const utm = getUtmParamsFromCookies()
        userSignup({
            email,
            password,
            first_name: firstName,
            last_name: lastName,
            phone_number: phoneNumber,
            ref_id: refId,
            ...utm
        });

    };


    useEffect(() => {
        if (userSignupData?.status) {
            LocalStorage.setItem(
                Tokens.ACCESS_TOKEN,
                userSignupData.data.user_access_token
            );
            LocalStorage.setItem(
                Tokens.REFRESH_TOKEN,
                userSignupData.data.refresh_user_access_token
            );

            displayToast("success", "User Signup Successful");
            deleteUTMCookies()
            dispatch(setUser(userSignupData.user));
            if (userSignupData.status) navigate(ROUTES.VERIFY_OTP_PAGE, { replace: true })
        }
        if (userSignupErr) {
            // setShowError(parseErrorMessage(verifyErr));
            displayToast("error", userSignupErr?.data?.message);
            console.error(userSignupErr?.data);
        }
    }, [userSignupData, userSignupErr]);



    return (
        <div className="w-full">
            <>
                <form className="w-full space-y-4">

                    {/* First & Last Name Fields */}

                    <div className="flex flex-row gap-4">
                        <div className="w-full">
                            <input
                                type="text"
                                name="firstname"
                                placeholder="First Name"
                                value={firstName}
                                onChange={handleChange}
                                className={`w-full px-4 py-3 rounded-lg bg-[#f9fafb33] border border-[#b5b5b5] ${errors.firstname ? "border-red-600" : ""} focus:outline-none focus:ring-2 focus:ring-[#7772FF] focus:border-transparent`}
                            />
                            {errors.firstname && <p className="text-xs text-red-500 mt-1">{errors.firstname}</p>}
                        </div>
                        <div className="w-full">
                            <input
                                type="text"
                                name="lastname"
                                placeholder="Last Name"
                                value={lastName}
                                onChange={handleChange}
                                className={`w-full px-4 py-3 rounded-lg bg-[#f9fafb33] border border-[#b5b5b5] ${errors.lastname ? "border-red-600" : ""} focus:outline-none focus:ring-2 focus:ring-[#7772FF] focus:border-transparent`}
                            />
                            {errors.lastname && <p className="text-xs text-red-500 mt-1">{errors.lastname}</p>}
                        </div>
                    </div>

                    {/* Phone Input */}
                    <div>
                        <style>
                            {`
                                    .PhoneInput {
                                        display: flex;
                                        align-items: center;
                                        gap: 8px;
                                        width: 100%;
                                        padding: 0.75rem 1rem;
                                        border-radius: 0.5rem;
                                        background-color: #f9fafb33;
                                        border: 1px solid #b5b5b5;
                                    }
                                    .PhoneInput:focus-within {
                                        outline: none;
                                        border-color: #7772FF;
                                        box-shadow: 0 0 0 2px rgba(119, 114, 255, 0.2);
                                    }
                                    .PhoneInputInput {
                                        border: none;
                                        background: transparent;
                                        padding: 0;
                                        outline: none;
                                        flex: 1;
                                    }
                                    .PhoneInputCountry {
                                        display: flex;
                                        align-items: center;
                                    }
                                `}
                        </style>
                        <PhoneInput
                            placeholder="Enter your phone number"
                            defaultCountry="IN"
                            countryCallingCodeEditable={false}
                            international
                            initialValueFormat="national"
                            value={phoneNumber}
                            onChange={setPhoneNumber}
                        />
                        {errors.phonenumber && <p className="text-xs text-red-500 mt-1">{errors.phonenumber}</p>}
                    </div>

                    {/* Email Field */}
                    <div>
                        <input
                            type="email"
                            name="email"
                            placeholder="Email Address"
                            value={email}
                            onChange={handleChange}
                            className="w-full px-4 py-3 rounded-lg bg-[#f9fafb33] border border-[#b5b5b5] focus:outline-none focus:ring-2 focus:ring-[#7772FF] focus:border-transparent"
                        />
                        {errors.email && <p className="text-xs text-red-500 mt-1">{errors.email}</p>}
                        {email && (
                            <p className="text-xs text-[#787781] mt-1">
                                Email will be sent to <span className="text-[#7772FF]">{email}</span> for verification
                            </p>
                        )}
                    </div>

                    {/* Password Field */}
                    <div>
                        <input
                            type="password"
                            name="password"
                            placeholder="Password"
                            value={password}
                            onChange={handleChange}
                            autoComplete="new-password"
                            className="w-full px-4 py-3 rounded-lg bg-[#f9fafb33] border border-[#b5b5b5] focus:outline-none focus:ring-2 focus:ring-[#7772FF] focus:border-transparent"
                        />
                        {!password && errors.password && (
                            <p className="text-xs text-red-500 mt-1">{errors.password}</p>
                        )}
                        {password && (
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mt-2">
                                <div className={`flex items-center gap-1 text-xs ${password.length >= 8 ? "text-emerald-500" : "text-red-500"}`}>
                                    <CheckCircledIcon className="w-4 h-4" />
                                    <span>Minimum 8 Characters</span>
                                </div>
                                <div className={`flex items-center gap-1 text-xs ${/(?=.*[a-z])(?=.*[A-Z])/.test(password) ? "text-emerald-500" : "text-red-500"}`}>
                                    <CheckCircledIcon className="w-4 h-4" />
                                    <span>Upper & Lower case</span>
                                </div>
                                <div className={`flex items-center gap-1 text-xs ${/\d/.test(password) ? "text-emerald-500" : "text-red-500"}`}>
                                    <CheckCircledIcon className="w-4 h-4" />
                                    <span>One Numerical (123)</span>
                                </div>
                                <div className={`flex items-center gap-1 text-xs ${/[!@#$%^&*(),.?":{}|<>]/.test(password) ? "text-emerald-500" : "text-red-500"}`}>
                                    <CheckCircledIcon className="w-4 h-4" />
                                    <span>Special Char (@#$%)</span>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Meta Verification Box */}
                    <div className="bg-[#F9F9FB] rounded-xl p-4 border border-black">
                        <div className="flex items-center justify-center gap-2 mb-2">
                            <img
                                src="https://img.icons8.com/?size=100&id=PvvcWRWxRKSR&format=png&color=000000"
                                alt="check"
                                className="w-8 h-8"
                            />
                            <h3 className="text-[#1877f2] font-semibold text-base">
                                We're a Meta-verified business
                            </h3>
                        </div>
                        <p className="text-[#787781] text-xs text-center">
                            We only use official Instagram APIs and processes.<br />
                            Your Instagram account is secure, and you stay in full control.
                        </p>
                    </div>

                    {/* Terms & Policy Notice */}
                    <div className="text-center">
                        <p className="text-xs text-[#787781]">
                            By signing up you agree to the{" "}
                            <a href="https://linkplease.co/terms-and-conditions/" className="text-[#6561FF] hover:underline">Terms</a> and{" "}
                            <a href="https://linkplease.co/privacy-policy" className="text-[#6561FF] hover:underline">Privacy Policy</a>
                        </p>
                    </div>

                    {/* Submit Button */}
                    <button
                        type="submit"
                        onClick={onSubmitClick}
                        className="w-full bg-[#3535d5] text-white py-3 rounded-lg font-medium hover:bg-[#6561FF] transition-colors disabled:opacity-50"
                    >
                        Create Account
                    </button>
                </form>

            </>
        </div>
    );
};

export default SignupForm;
